module.exports = __webpack_public_path__ + "static/media/ic_seats_book.8e1d71aa.png";